import {Flyout_LogoContainer_FlyoutSection_FlyoutSectionItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/navigation_bar.types';
import {Link, useHandleNavigationWithSpecialKeys} from '@aboutyou/router';
import {TrackLogoSectionItem} from '@aboutyou/tracking';
import {
  COLORS,
  FONT_SIZES,
  Image,
  mediaDesktopAndUp,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {useTrackBrandItemOriginClick} from '../../../hooks/useOriginClickTrackingFunction';

export const LogoSectionItem: FC<{
  dataTestId: string;
  sectionItem: Flyout_LogoContainer_FlyoutSection_FlyoutSectionItem;
  streamPosition: number;
}> = ({dataTestId, sectionItem, streamPosition}) => {
  const onBrandItemClick = useTrackBrandItemOriginClick();
  const {promotionTracking, brandLogo, targetUrl} = sectionItem;

  const handleOverrideNavigation = useHandleNavigationWithSpecialKeys({
    to: targetUrl.url,
  });

  const handleOnClick = (event: React.MouseEvent) => {
    onBrandItemClick();

    if (targetUrl.canonicalUrl) {
      handleOverrideNavigation?.(event);
    }
  };

  return (
    <TrackLogoSectionItem
      promotionTrackingData={promotionTracking}
      promoPath={brandLogo.path}
      streamPosition={streamPosition}
    >
      <StyledLink
        data-testid={dataTestId}
        to={`${targetUrl.canonicalUrl || targetUrl.url}`}
        onClick={handleOnClick}
      >
        {brandLogo.blackLogoImage && (
          <BrandLogoImg
            data-testid={`${dataTestId}_brandLogo`}
            alt={brandLogo.blackLogoImage.description}
            src={brandLogo.blackLogoImage.url}
            ratio="1:1"
            loading="lazy"
            breakpoints={[]}
            widths={[400]}
          />
        )}
        <BrandLogoName
          data-testid={`${dataTestId}_brandLogoName`}
          data-active={!brandLogo.blackLogoImage}
        >
          {brandLogo.name}
        </BrandLogoName>
      </StyledLink>
    </TrackLogoSectionItem>
  );
};

const BrandLogoImg = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;
  mix-blend-mode: multiply;
  filter: grayscale(1);
`;

const BrandLogoName = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  font-size: ${FONT_SIZES.px10};
  color: ${COLORS.Black};
  white-space: pre-wrap;
  word-break: break-word;
  opacity: 0;
  transition: opacity, color 0.3s;

  &[data-active='true'] {
    opacity: 1;
  }

  &:hover {
    color: ${COLORS.Grey1};
  }
`;

const StyledLink = styled(Link)`
  display: flex;
  position: relative;
  width: 90px;
  height: 50px;
  background: ${COLORS.Grey4};
  padding: 6px 18px;
  overflow: hidden;

  @media ${mediaDesktopAndUp} {
    width: 100px;
    height: 56px;
  }

  &:hover {
    background: ${COLORS.Grey3};

    ${BrandLogoName} {
      opacity: 1;
      color: ${COLORS.Grey1};
    }

    ${BrandLogoImg} {
      opacity: 0;
    }
  }
`;
